import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const ClientInfoSection = ({ 
  clientInfo, 
  onClientInfoChange, 
  errors = {},
  isCollapsed = false,
  onToggleCollapse 
}) => {
  const handleInputChange = (field, value) => {
    onClientInfoChange({
      ...clientInfo,
      [field]: value
    });
  };

  return (
    <div className="bg-surface border border-border rounded-lg">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer"
        onClick={onToggleCollapse}
      >
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-full">
            <Icon name="User" size={16} color="white" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-text-primary">Informations Client</h3>
            <p className="text-sm text-text-secondary">Détails du client et coordonnées</p>
          </div>
        </div>
        <Icon 
          name={isCollapsed ? "ChevronDown" : "ChevronUp"} 
          size={20} 
          className="text-text-secondary" 
        />
      </div>
      {!isCollapsed && (
        <div className="px-4 pb-4 border-t border-border">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            <Input
              label="Nom *"
              type="text"
              placeholder="Nom du client"
              value={clientInfo?.lastName || ''}
              onChange={(e) => handleInputChange('lastName', e?.target?.value)}
              error={errors?.lastName}
              required
            />
            
            <Input
              label="Prénom *"
              type="text"
              placeholder="Prénom du client"
              value={clientInfo?.firstName || ''}
              onChange={(e) => handleInputChange('firstName', e?.target?.value)}
              error={errors?.firstName}
              required
            />
            
            <div className="md:col-span-2">
              <Input
                label="Adresse postale *"
                type="text"
                placeholder="Adresse complète du client"
                value={clientInfo?.address || ''}
                onChange={(e) => handleInputChange('address', e?.target?.value)}
                error={errors?.address}
                required
              />
            </div>
            
            <Input
              label="Téléphone *"
              type="tel"
              placeholder="06 12 34 56 78"
              value={clientInfo?.phone || ''}
              onChange={(e) => handleInputChange('phone', e?.target?.value)}
              error={errors?.phone}
              required
            />
            
            <Input
              label="Email *"
              type="email"
              placeholder="client@example.com"
              value={clientInfo?.email || ''}
              onChange={(e) => handleInputChange('email', e?.target?.value)}
              error={errors?.email}
              required
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientInfoSection;